export default [{
  connections: 1,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '7.51KB',
  requestsPerSec: 71.85,
  non2xx3xx: 724,
  requestsTotal: 724,
  durationActual: '10.08s',
  transferTotal: '75.65KB',
  latencyAvg: '10.76ms',
  latencyStdev: '17.37ms',
  latencyMax: '203.55ms',
  latencyStdevPerc: 95.77,
  rpsAvg: '72.76',
  rpsStdev: '18.82',
  rpsMax: '90.00',
  rpsStdevPerc: 84.85,
  latency50: '7.01ms',
  latency75: '8.56ms',
  latency90: '10.95ms',
  latency99: '106.13ms'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '6.55KB',
  requestsPerSec: 62.7,
  connectErrors: '0',
  readErrors: '645',
  writeErrors: '0',
  timeoutErrors: '0',
  non2xx3xx: 632,
  requestsTotal: 632,
  durationActual: '10.08s',
  transferTotal: '66.04KB',
  latencyAvg: '13.72ms',
  latencyStdev: '31.16ms',
  latencyMax: '375.33ms',
  latencyStdevPerc: 97.07,
  rpsAvg: '64.57',
  rpsStdev: '14.64',
  rpsMax: '80.00',
  rpsStdevPerc: 77.32,
  latency50: '8.57ms',
  latency75: '9.44ms',
  latency90: '11.84ms',
  latency99: '183.93ms'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourB',
  transferPerSec: '3.34KB',
  requestsPerSec: 31.99,
  connectErrors: '0',
  readErrors: '1976',
  writeErrors: '0',
  timeoutErrors: '0',
  non2xx3xx: 321,
  requestsTotal: 321,
  durationActual: '10.03s',
  transferTotal: '33.54KB',
  latencyAvg: '12.62ms',
  latencyStdev: '4.84ms',
  latencyMax: '56.16ms',
  latencyStdevPerc: 95.95,
  rpsAvg: '32.00',
  rpsStdev: '6.57',
  rpsMax: '50.00',
  rpsStdevPerc: 56,
  latency50: '11.82ms',
  latency75: '13.43ms',
  latency90: '14.86ms',
  latency99: '34.16ms'
},
{
  connections: 1,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '250.96KB',
  requestsPerSec: 63.02,
  requestsTotal: 634,
  durationActual: '10.06s',
  transferTotal: '2.47MB',
  latencyAvg: '10.34ms',
  latencyStdev: '4.81ms',
  latencyMax: '60.64ms',
  latencyStdevPerc: 94.09,
  rpsAvg: '63.16',
  rpsStdev: '11.52',
  rpsMax: '70.00',
  rpsStdevPerc: 86,
  latency50: '8.90ms',
  latency75: '10.43ms',
  latency90: '11.92ms',
  latency99: '36.60ms'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '237.15KB',
  requestsPerSec: 59.62,
  connectErrors: '0',
  readErrors: '607',
  writeErrors: '0',
  timeoutErrors: '0',
  requestsTotal: 600,
  durationActual: '10.06s',
  transferTotal: '2.33MB',
  latencyAvg: '10.99ms',
  latencyStdev: '3.34ms',
  latencyMax: '49.38ms',
  latencyStdevPerc: 93.83,
  rpsAvg: '59.73',
  rpsStdev: '8.11',
  rpsMax: '70.00',
  rpsStdevPerc: 63,
  latency50: '10.13ms',
  latency75: '11.21ms',
  latency90: '13.44ms',
  latency99: '29.02ms'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourKB',
  transferPerSec: '119.10KB',
  requestsPerSec: 29.94,
  connectErrors: '0',
  readErrors: '1727',
  writeErrors: '0',
  timeoutErrors: '0',
  requestsTotal: 301,
  durationActual: '10.05s',
  transferTotal: '1.17MB',
  latencyAvg: '15.79ms',
  latencyStdev: '21.03ms',
  latencyMax: '366.63ms',
  latencyStdevPerc: 98.01,
  rpsAvg: '30.66',
  rpsStdev: '7.56',
  rpsMax: '50.00',
  rpsStdevPerc: 56.7,
  latency50: '13.36ms',
  latency75: '15.27ms',
  latency90: '16.98ms',
  latency99: '46.35ms'
},
{
  connections: 1,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '3.81KB',
  requestsPerSec: 0.6,
  requestsTotal: 6,
  durationActual: '10.03s',
  transferTotal: '38.25KB',
  latencyAvg: '1.57s',
  latencyStdev: '32.58ms',
  latencyMax: '1.62s',
  latencyStdevPerc: 83.33,
  rpsAvg: '0.00',
  rpsStdev: '0.00',
  rpsMax: '0.00',
  rpsStdevPerc: 100,
  latency50: '1.57s',
  latency75: '1.58s',
  latency90: '1.62s',
  latency99: '1.62s'
},
{
  connections: 2,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '3.62KB',
  requestsPerSec: 0.6,
  connectErrors: '0',
  readErrors: '6',
  writeErrors: '0',
  timeoutErrors: '0',
  requestsTotal: 6,
  durationActual: '10.06s',
  transferTotal: '36.42KB',
  latencyAvg: '1.65s',
  latencyStdev: '54.41ms',
  latencyMax: '1.72s',
  latencyStdevPerc: 50,
  rpsAvg: '0.00',
  rpsStdev: '0.00',
  rpsMax: '0.00',
  rpsStdevPerc: 100,
  latency50: '1.66s',
  latency75: '1.70s',
  latency90: '1.72s',
  latency99: '1.72s'
},
{
  connections: 8,
  url: 'http://192.168.1.113/fourKBloop',
  transferPerSec: '3.63KB',
  requestsPerSec: 0.6,
  connectErrors: '0',
  readErrors: '39',
  writeErrors: '0',
  timeoutErrors: '0',
  requestsTotal: 6,
  durationActual: '10.03s',
  transferTotal: '36.39KB',
  latencyAvg: '1.63s',
  latencyStdev: '68.75ms',
  latencyMax: '1.76s',
  latencyStdevPerc: 83.33,
  rpsAvg: '0.00',
  rpsStdev: '0.00',
  rpsMax: '0.00',
  rpsStdevPerc: 100,
  latency50: '1.61s',
  latency75: '1.67s',
  latency90: '1.76s',
  latency99: '1.76s'
}];
